import applicationFocus from '../../constants/applicationFocus';
import { APPLICATION_MODES } from '../../constants/itemTypes/itemTypes';

interface BrowserState {
    canSelectMultipleElements: boolean,
    browserName: '',
    OSName: '',
    windowInnerWidth: number | null,
    modifierKeyPressed: boolean,
    shiftKeyPressed: boolean,
    leftPanelCollapsed: boolean,
    applicationFocus: typeof applicationFocus[keyof typeof applicationFocus],
    appMode: typeof APPLICATION_MODES[keyof typeof APPLICATION_MODES],
}
const defaultState: BrowserState = {
    canSelectMultipleElements: false,
    browserName: '',
    OSName: '',
    windowInnerWidth: null,
    modifierKeyPressed: false,
    shiftKeyPressed: false,
    leftPanelCollapsed: true,
    applicationFocus: applicationFocus.NONE,
    appMode: APPLICATION_MODES.EDITOR,
};

export default defaultState;
